import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumbs } from '@opendate-app/setlist';
import CrmPageLayout from '../../shared/components/CrmPageLayout';
import TagsManager from '../../shared/components/TagsManager';

function CrmTagsPage({ csrfToken, team, scopes = [], canManageTags = false }) {
  return (
    <CrmPageLayout
      team={team}
      activeSidebarKey="settings"
      mainTopMargin={32}
      breadcrumb={<Breadcrumbs items={[{ label: 'Settings', href: team ? `/teams/${team.id}/crm-settings` : undefined }, { label: 'Tags' }]} />}
      title="Tags"
      subtitle="Rename, delete, and merge tags across your CRM."
    >
      <TagsManager
        csrfToken={csrfToken}
        team={team}
        scopes={scopes}
        canManageTags={canManageTags}
      />
    </CrmPageLayout>
  );
}

CrmTagsPage.propTypes = {
  csrfToken: PropTypes.string,
  team: PropTypes.object,
  scopes: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })),
  canManageTags: PropTypes.bool,
};

export default CrmTagsPage;
